import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { StorybookModule } from '@storybook/storybook.module';
import { AddProductsModalComponent } from './components/add-products-modal/add-products-modal.component';
import { SelectedProductsSummaryComponent } from './components/selected-products-summary/selected-products-summary.component';
import { EditProductModalComponent } from './components/edit-product-modal/edit-product-modal.component';

// Reusable product-selection UI (selected-products summary + add/edit product modals), shared across features.
// The product list itself is the storybook `pdq-product-list`.
@NgModule({
  declarations: [SelectedProductsSummaryComponent, AddProductsModalComponent, EditProductModalComponent],
  imports: [CommonModule, FormsModule, MatDialogModule, DragDropModule, StorybookModule],
  exports: [SelectedProductsSummaryComponent, AddProductsModalComponent, EditProductModalComponent],
})
export class ProductSelectionModule {}
